import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/shared/plugins/axios'
import utils from '@/shared/plugins/utils'

// we can access router now, but I think better will be to pass router data to action call from component
//import router from '../router'

import auth from './Auth/index'
import valuationStore from '@/apps/Valuation/store'
import ersStore from '@/apps/ERS/store'

Vue.use(Vuex)

const getDefaultState = () => {
    return {
        loading: false,
        helpPage: null,
        unread_messages: null,
    }
}

const state = getDefaultState()

export default new Vuex.Store({
    state,
    getters: {
        flow_type(state) {
            return Vue.prototype.$config.FLOW_TYPE
        },
        hasUnreadMessages(state) {
            return !!state.unread_messages
        },
        getFullStore(state, getters, rootState, rootGetters) {
            let data = { ...state }
            data.valuationStore = rootGetters['valuationStore/getFullValuationStore']
            data.auth = rootGetters['auth/']
            return data
        },
    },
    mutations: {
        SET_HELP_PAGE(state, page) {
            state.helpPage = page
        },
        SET_UNREAD_MESSAGES(state, unread_messages) {
            state.unread_messages = unread_messages
        },
    },
    actions: {},
    modules: {
        auth,
        valuationStore,
        ersStore,
    },
})
